<template>
    <v-dialog v-model="dialog" scrollable max-width="400px" hide-overlay>
        <template v-slot:activator="{ on }">
            <v-btn color="secondary" class="text-lowercase mr-4" dark small v-on="on">add team</v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6">
                New team parameters by {{ set.item }} game
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="black--text">
                <v-container grid-list-md>
                    <v-form v-model="valid" ref="form" validation>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-text-field dense color="primary"
                                    label="Team name" 
                                    v-model="name" name="name"
                                    type="text" :rules="[rules.required]">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
                <v-row justify="center" class="error">{{ error }}</v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text class="text-capitalize" @click="closeDialog">
                    Close
                </v-btn>
                <v-btn color="primary" text class="text-capitalize" :disabled="!valid || Boolean(error)"
                    @click="addTeam">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: 'AddTeam',
    props: ['set'],
    data() {
        return {
            dialog: false,
            valid: false,
            error: '',
            rules: {
                required: v => !!v || 'this field is required',
                number: v => /^[+]?[0-9]/.test(v) || 'it\'s expected number'
            },
            name: '',
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        games() {
            return this.$store.getters.games;
        }
    },
    methods: {

        onceMore() {
            this.error = ''
        },
        async addTeam() {

            if (this.$refs.form.validate()) {
                const team = {
                    gameId: this.set.value,
                    name: this.name,
                }

                try {
                    //add team
                    await this.$store.dispatch('addTeam', team)
                    this.closeDialog()
                }
                catch (error) {
                    this.$store.dispatch('setError', error.message)//throw error
                }
            }
        },
        closeDialog() {
            //reset
            this.dialog = false;
            this.error = '';
            this.name = '';
        }
    },
    async mounted() {
        if (this.games.length < 1 && this.user) {
            try {
                await this.$store.dispatch('fetchUserGames')
            }
            catch (error) {
                console.log(error.message);
            }
        }
    }
}
</script>
